import { ROOT_CONFIG_LOCAL_STORAGE_KEY } from '@ptml/root-config';

import styles from './authentication-status.module.css';

const AUTHENTICATION_STATUS_SELECTOR = 'authentication-status';
const AUTHENTICATION_PENDING_MESSAGE = 'Authentication check in progress. Please wait...';
const AUTHENTICATION_ERROR_MESSAGE =
    'We could not complete the authentication check. Please refresh the page and try again.';
const REQUIRED_ROLE_ERROR_MESSAGE = 'You do not have the required role to access this application.';

export class AuthenticationStatus extends HTMLElement {
    public connectedCallback(): void {
        this.classList.add(styles.authenticationStatus);

        if (AuthenticationStatus.hasStoredUser()) {
            this.hidden = true;
            return;
        }

        this.showMessage(AUTHENTICATION_PENDING_MESSAGE, 'status', 'polite');
    }

    public static removeFromDocument(): void {
        AuthenticationStatus.getInstance()?.remove();
    }

    public static showAuthenticationCheckError(): void {
        AuthenticationStatus.getInstance()?.showMessage(
            AUTHENTICATION_ERROR_MESSAGE,
            'alert',
            'assertive',
        );
    }

    public static showRequiredRoleError(): void {
        AuthenticationStatus.getInstance()?.showMessage(
            REQUIRED_ROLE_ERROR_MESSAGE,
            'alert',
            'assertive',
        );
    }

    private static getInstance(): AuthenticationStatus | null {
        return document.querySelector<AuthenticationStatus>(AUTHENTICATION_STATUS_SELECTOR);
    }

    private static hasStoredUser(): boolean {
        const storedConfig = globalThis.localStorage?.getItem(ROOT_CONFIG_LOCAL_STORAGE_KEY);
        if (!storedConfig) {
            return false;
        }

        try {
            const config: unknown = JSON.parse(storedConfig);
            if (typeof config !== 'object' || config === null || !('user' in config)) {
                return false;
            }

            return typeof config.user === 'object' && config.user !== null;
        } catch {
            return false;
        }
    }

    private showMessage(message: string, role: string, live: string): void {
        const messageElement = document.createElement('p');
        messageElement.textContent = message;

        this.hidden = false;
        this.setAttribute('role', role);
        this.setAttribute('aria-live', live);
        this.setAttribute('aria-atomic', 'true');
        this.replaceChildren(messageElement);
    }
}

customElements.define(AUTHENTICATION_STATUS_SELECTOR, AuthenticationStatus);
